import React from "react";
import { Modal, ModalOpen, ModalClose } from '../Modal';
import { Table, Button } from "reactstrap";
import { T } from '../traks';
import { determinePaymentMethod } from "./PremiumKeys/ThankYou/ThankYouUtils";
import { formatDate, formatPrice } from "./PremiumKeys/Globals/GlobalUtils";
import { determineExpirationDate } from "./PremiumKeys/Order/OrderUtils";
import { determineCurrency } from "../misc";

function OrderDetailsModalInit(data) {
    ModalOpen("OrderDetailsModal", data);
}

const OrderDetailsInnerContent = (props) => {
    const expirationDate = determineExpirationDate(props.StartDate, props.NumMonths);
    const vatRate = 0.25;

    if (!props.Id) {
        return null;
    }

    return (
        <div className="ad_trade_bg p-4">
            <div className="modal-body">
            <Table striped bordered hover>
                <tbody>
                    <tr>
                        <td><T>Order number</T></td>
                        <td>{props.Id}</td>
                    </tr>
                    <tr>
                        <td><T>Name</T></td>
                        <td>
                            {props.Name}
                        </td>
                    </tr>
                    <tr>
                        <td><T>E-mail</T></td>
                        <td>
                            {props.Email}
                        </td>
                    </tr>
                    <tr>
                        <td><T>Phone</T></td>
                        <td>
                            {props.Phone}
                        </td>
                    </tr>
                    <tr>
                        <td><T>Country</T></td>
                        <td>
                            {props.Country}
                        </td>
                    </tr>
                    <tr>
                        <td><T>City</T></td>
                        <td>
                            {props.City}
                        </td>
                    </tr>
                    <tr>
                        <td><T>Postal code</T></td>
                        <td>
                            {props.Postalcode}
                        </td>
                    </tr>
                    <tr>
                        <td><T>Address</T></td>
                        <td>
                            {props.StreetAddress}
                        </td>
                    </tr>
                    <tr>
                        <td><T>Payment method</T></td>
                        <td>{determinePaymentMethod(props.PaymentMethod)}</td>
                    </tr>
                    {(props.PaymentMethod === 'ean' && props.Ean) && (
                        <tr>
                            <td><T>EAN</T></td>
                            <td>
                                {props.Ean.String}
                            </td>
                        </tr>
                    )}
                    {(props.PaymentMethod === 'ean' && props.Cvr) && (
                        <tr>
                            <td><T>CVR</T></td>
                            <td>
                                {props.Cvr.String}
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td><T>Order status</T></td>
                        <td>{props.Status}</td>
                    </tr>
                    {/* {orderDetails.payment.order.game && (
                        <tr>
                            <td><T>Game Upgrade</T></td>
                            <td>
                                {orderDetails.payment.order.game}
                            </td>
                        </tr>
                    )} */}
                    <tr>
                        <td><T>Premium Key</T></td>
                        <td>
                            <T>Players: </T> {props.NumKeys} <T>Months: </T>
                            {props.NumMonths}
                        </td>
                    </tr>
                    <tr>
                        <td><T>Start Date</T></td>
                        <td>
                            {formatDate(new Date(props.StartDate))}
                        </td>
                    </tr>
                    <tr>
                        <td><T>Premium valid until</T></td>
                        <td>
                            {formatDate(new Date(expirationDate))}
                        </td>
                    </tr>
                    <tr>
                        <td><T>VAT</T></td>
                        <td>25%</td>
                    </tr>
                    <tr>
                        <td><T>Total price</T></td>
                        <td>
                            {formatPrice(props.Amount)} {determineCurrency(props.Country)}&nbsp;
                            ({formatPrice(props.Amount / (1 + vatRate))} {determineCurrency(props.Country)} <T>excl. VAT</T>)
                        </td>
                    </tr>
                </tbody>
            </Table>
            </div>
            <div className="modal-footer">
                <Button onClick={ModalClose} color="secondary">
                    <T>Close</T>
                </Button>
            </div>
        </div>
    );
};

// This class sets up the modal just like AdminActionsModal does.
class OrderDetailsModal extends Modal {
    allow_close_via_ui() {
        return true;
    }

    mrender() {
        return <OrderDetailsInnerContent {...this.props} />;
    }

    get_name() {
        return "OrderDetailsModal";
    }

    get_fullscreen() {
        return false; 
    }
}

export {
    OrderDetailsModalInit,
    OrderDetailsModal
};


// WEBPACK FOOTER //
// ./src/c/OrderDetailsModal.js